import React from 'react';
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from "@mui/material/Select";

const MuiSelect = ({functionName, Title, data, stateName, labelTitle}) => {
  return (
    <Box sx={{ minWidth: 120 }}>
        <div className='admin-add-label'>
        <label htmlFor={labelTitle} className='admin-add-label'>{labelTitle}:</label>
        </div>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{Title}</InputLabel>
                <Select
                  id="demo-simple-select"
                  value={stateName || ""}
                  label=""
                  onChange={functionName}
                  inputlabelprops={{shrink: false}}
                >
                  {data?.map((item, index) => {
                    return (
                      <MenuItem value={item} key={index}>
                        {item.toUpperCase()}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
  )
}

export default MuiSelect;